<script setup>
const props = defineProps({
  title: String,
});
</script>

<template>
  <div class="livestream absolute inset-0">
    <img
      src="/img/livestream.jpg"
      class="absolute inset-0 w-full h-full object-cover object-center z-0"
    />
    <div class="absolute z-0 top-[30px] right-[30px] flex flex-wrap">
      <div
        class="h-40px md:h-50px flex flex-wrap items-center bg-white text-black uppercase text-sm font-bold rounded-xs px-md"
      >
        <div class="flex-shrink-0">
          <div class="w-20px h-20px bg-red rounded-full mr-xs"></div>
        </div>
        <div class="flex-grow">Live</div>
      </div>
      <div
        class="w-40px h-40px md:h-50px md:w-50px flex flex-wrap items-center justify-center bg-black text-white rounded-xs ml-xs"
      >
        <IconExpand />
      </div>
    </div>
    <div
      class="tile__content block w-full absolute bottom-0 px-md pt-md pb-xs text-white z-1"
    >
      <h2 v-if="title" class="h3 font-bold">{{ title }}</h2>
    </div>
  </div>
</template>

<style></style>
